// node modules
import React from 'react';

// app modules: components
import Layout from 'components/Layout';
import CollectionsTabs from 'components/CollectionsTabs';
import HeadContent from 'components/HeadContent';
import MyCollections from 'components/MyCollections';
import CollectionsView from './CollectionsView';

async function action({ pathname }, { tag }) {
  const ucFirstTag = tag ? tag.charAt(0).toUpperCase() + tag.slice(1) : '';
  const title = tag === 'neff' ? 'NEFF Collections' : `${ucFirstTag} Collections`;

  let tabContent = null;
  if (!tag) {
    tabContent = (
      <div role="tabpanel" id="collections-tabpanel-mine" className="in-column">
        <MyCollections />
      </div>
    );
  } else {
    tabContent = (
      <div role="tabpanel" id={`collections-tabpanel-${tag}`}>
        <CollectionsView tags={[tag]} />
      </div>
    );
  }

  const description = `${title}: ckbk is the ultimate digital subscription service for anyone who loves to cook.`;
  return {
    chunks: ['collections'],
    navigation: {
      heading: 'Collections',
      section: 'Collections',
      left: null,
    },
    component: (
      <Layout type="full" withLeaderboardAd={false} withFooterLeaderboardAd={false}>
        <HeadContent
          contents={{
            title,
            description,
            url: pathname,
          }}
        />
        <div className="margin-top-20">
          <CollectionsTabs selectedTab={tag} />
        </div>
        {tabContent}
      </Layout>
    ),
  };
}

export default action;
